(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["petco-size-guide"] && !Shopify.designMode) return;
  try {
    /* PET & Co. size guide. No theme-specific variant or cart dependencies. */
(() => {
  if (customElements.get('petco-size-guide')) return;

  let scrollState = null;
  const openGuides = new Set();
  const lockScroll = (guide) => {
    if (!openGuides.size) {
      const root = document.documentElement;
      scrollState = {
        overflow: root.style.overflow,
        paddingRight: root.style.paddingRight,
      };
      const scrollbar = window.innerWidth - root.clientWidth;
      const padding = parseFloat(getComputedStyle(root).paddingRight) || 0;
      root.style.overflow = 'hidden';
      if (scrollbar > 0) root.style.paddingRight = `${padding + scrollbar}px`;
    }
    openGuides.add(guide);
  };
  const unlockScroll = (guide) => {
    openGuides.delete(guide);
    if (!openGuides.size && scrollState) {
      if (document.documentElement) Object.assign(document.documentElement.style, scrollState);
      scrollState = null;
    }
  };

  class PetcoSizeGuide extends HTMLElement {
    connectedCallback() {
      // A previously registered element can connect before the HTML parser has
      // reached its children. Initialize on the next task, after they exist.
      clearTimeout(this.initTimer);
      this.initTimer = setTimeout(() => this.initialize(), 0);
    }

    initialize() {
      if (!this.isConnected) return;
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-pcsg-open]');
      if (!this.dialog || !this.trigger) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelectorAll('[data-pcsg-close]').forEach((button) => {
        button.addEventListener('click', () => this.close(), options);
      });

      // Only close when both pointer down and click happened on the backdrop.
      this.dialog.addEventListener('pointerdown', (event) => {
        this.backdropPointer = event.target === this.dialog && this.isOutside(event);
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (this.backdropPointer && event.target === this.dialog && this.isOutside(event)) this.close();
        this.backdropPointer = false;
      }, options);
      this.dialog.addEventListener('close', () => {
        unlockScroll(this);
        if (this.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);

      this.querySelectorAll('[data-pcsg-tabs]').forEach((tablist) => {
        const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activateTab(tabs, tab), options);
          tab.addEventListener('keydown', (event) => {
            let next;
            const rtl = getComputedStyle(tablist).direction === 'rtl';
            if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
            if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            const target = tabs[(next + tabs.length) % tabs.length];
            this.activateTab(tabs, target);
            target.focus();
          }, options);
        });
      });

      document.addEventListener('shopify:block:select', (event) => {
        if (event.target === this || this.contains(event.target) || event.target.contains(this)) this.open();
      }, options);
      document.addEventListener('shopify:block:deselect', (event) => {
        if (event.target === this || this.contains(event.target) || event.target.contains(this)) this.close();
      }, options);
    }

    disconnectedCallback() {
      clearTimeout(this.initTimer);
      if (this.dialog?.open) this.dialog.close();
      unlockScroll(this);
      this.controller?.abort();
      this.controller = null;
    }

    isOutside(event) {
      const rect = this.dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right ||
        event.clientY < rect.top || event.clientY > rect.bottom;
    }

    activateTab(tabs, selected) {
      tabs.forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panelId = tab.getAttribute('aria-controls');
        // Scope lookup to this instance; quick views can render the same product.
        const panel = Array.from(this.querySelectorAll('[role="tabpanel"]'))
          .find((element) => element.id === panelId);
        if (panel) panel.hidden = !active;
      });
      this.querySelector('.pcsg__body').scrollTop = 0;
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      lockScroll(this);
      this.dialog.querySelector('[data-pcsg-close]').focus({ preventScroll: true });
      this.dialog.scrollTop = 0;
      this.querySelector('.pcsg__body').scrollTop = 0;
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }
  }

  customElements.define('petco-size-guide', PetcoSizeGuide);
})();
  } catch(e) { console.error(e); }
})();

})();
